import AppTrans from '~/components/common/AppTrans';
import Link from '~/components/common/Link';
import { OverHighlight } from '~/components/MeteringUsage/elements';
import { HELP_PAGE_ID } from '~/constants/helpPage';
import { globalSettingStore } from '~/stores/GlobalSettingStore';
import { getHelpUrl } from '~/utils/helpUrlUtil';
import * as React from 'react';
import styled from 'styled-components';

type Prop = {
  isMeChannel: boolean;
};

const MeteringOverAlertContent: React.FC<Prop> = ({ isMeChannel }) => {
  const helpUrl = {
    unavailableFeatures: getHelpUrl({
      helpUrl: globalSettingStore.env.helpUrl,
      locale: globalSettingStore.env.locale,
      pageId: HELP_PAGE_ID['3000919820354205619'],
    }),
    storageGuide: getHelpUrl({
      helpUrl: globalSettingStore.env.helpUrl,
      locale: globalSettingStore.env.locale,
      pageId: HELP_PAGE_ID['2895665675343408345'],
    }),
  };

  if (isMeChannel) {
    return (
      <Wrapper>
        <AppTrans i18nKey="metering.me.overAlert.content">개인 용량 초과로 해당 기능을 이용할 수 없습니다.</AppTrans>
        <br />
        <AppTrans i18nKey="metering.me.overAlert.todo">개인 데이터를 정리해 여유 공간을 확보해 주세요.</AppTrans>
        <br />
        <br />
        <Link href="/setting/general/metering">
          <AppTrans i18nKey="metering.usePersonalUsage">개인 사용량 확인</AppTrans>
        </Link>
        <br />
        {helpUrl.unavailableFeatures && (
          <Link href={helpUrl.unavailableFeatures}>
            <AppTrans i18nKey="metering.notUseFeature">이용 불가 기능 보기</AppTrans>
          </Link>
        )}
        <br />
        {helpUrl.storageGuide && (
          <Link href={helpUrl.storageGuide}>
            <AppTrans i18nKey="metering.removeData.backupHelp">데이터 삭제 및 백업 도움말</AppTrans>
          </Link>
        )}
      </Wrapper>
    );
  }
  return (
    <Wrapper>
      <AppTrans i18nKey="metering.public.overAlert.content">
        공용 용량 <OverHighlight>초과</OverHighlight>로 해당 기능을 이용할 수 없습니다.
      </AppTrans>
      <br />
      <AppTrans i18nKey="metering.public.overAlert.deniedFeature">
        프로젝트 최대 용량이 남아 있어도 공용 용량 부족 시 일부 기능 이용이 제한됩니다.
      </AppTrans>
      <br />
      <AppTrans i18nKey="metering.public.overAlert.todo">공용 데이터를 정리해 여유 공간을 확보해 주세요.</AppTrans>
      <br />
      <br />
      {helpUrl.unavailableFeatures && (
        <Link href={helpUrl.unavailableFeatures}>
          <AppTrans i18nKey="metering.notUseFeature">이용 불가 기능 보기</AppTrans>
        </Link>
      )}
      <br />
      {helpUrl.storageGuide && (
        <Link href={helpUrl.storageGuide}>
          <AppTrans i18nKey="metering.removeData.backupHelp">데이터 삭제 및 백업 도움말</AppTrans>
        </Link>
      )}
    </Wrapper>
  );
};

const Wrapper = styled.div`
  text-align: left;
`;

export default MeteringOverAlertContent;
